import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CONTENTFUL_IS_PREVIEW } from 'config/env';
import { axios } from 'utils/axios';

export const getReadingTimeData = async (articleId: string | null): Promise<number> => {
  const { data: readingTime } = await axios.get<number>(
    `/gql/readingTime/${articleId}?preview=${CONTENTFUL_IS_PREVIEW}`
  );

  return readingTime;
};

export const useReadingTime = (articleId: string | null): UseQueryResult<number, unknown> => {
  return useQuery({
    queryKey: [`readingTime-${articleId}`],
    queryFn: () => getReadingTimeData(articleId),
    enabled: !!articleId,
  });
};
